/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Userpausereasons2Inputs */

const en_entity_userpausereasons2 = /** @type {(inputs: Entity_Userpausereasons2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User Pause Reasons`)
};

const de_entity_userpausereasons2 = /** @type {(inputs: Entity_Userpausereasons2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzer-Pausegründe`)
};

/**
* | output |
* | --- |
* | "User Pause Reasons" |
*
* @param {Entity_Userpausereasons2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_userpausereasons2 = /** @type {((inputs?: Entity_Userpausereasons2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Userpausereasons2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_userpausereasons2(inputs)
	return de_entity_userpausereasons2(inputs)
});
export { entity_userpausereasons2 as "entity_userPauseReasons" }